import {
  ACCEPTANCE_CRITERIA_OPTION,
  IAcceptanceCriteriaFormValues,
} from '@src/features/shift-post-v2/steps/acceptance-criteria-step/acceptance-criteria-step.types'
import { getSelectedAcceptanceCriteriaOption } from '@src/features/shift-post-v2/utils'
import { FormikProps } from 'formik'
import { useMemo } from 'react'

export const useSelectedOption = (formik: FormikProps<IAcceptanceCriteriaFormValues>) => {
  const { setFieldValue, values } = formik
  const prevAutoAcceptanceCriteriaOption = useMemo(
    () => getSelectedAcceptanceCriteriaOption(values.auto_accept_by_rosters, values.auto_accept),
    [values.auto_accept_by_rosters, values.auto_accept]
  )

  const handleSelectedOptionChange = async (value: number) => {
    const resetAutoAcceptByRosters = async () => {
      await setFieldValue('auto_accept_by_rosters', false)
      await setFieldValue('auto_accept_rosters', [])
      await setFieldValue('auto_accept_roster_ids', [])

      if (prevAutoAcceptanceCriteriaOption === ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS) {
        await setFieldValue('roster_ids', [])
      }
    }

    switch (value) {
      case ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS:
        await setFieldValue('auto_accept_by_rosters', true)
        await setFieldValue('auto_accept', true)
        break

      case ACCEPTANCE_CRITERIA_OPTION.VERIFIED:
        await setFieldValue('auto_accept', true)
        resetAutoAcceptByRosters()
        break

      case ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED:
        await setFieldValue('auto_accept', false)
        resetAutoAcceptByRosters()
        break

      default:
        break
    }
  }

  return {
    handleSelectedOptionChange,
  }
}
